exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "calendar-inline-hide .container{width:300px;height:40px;border:1px solid #f9f9f9;padding-left:10px}calendar-inline-hide .text{cursor:pointer;font-family:Stag Sans;font-size:13px;color:#287cba}calendar-inline-hide .icon{font-size:22px;color:#287cba;padding-right:5px;position:relative;top:5px;padding-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHide/calendarInlineHide.scss
// module id = 1495
// module chunks = 0